// extracted by mini-css-extract-plugin
module.exports = {"routeTitle":"ParentRouteRedirect_routeTitle__sGWWu","cohortAnalyserRouteTitle":"ParentRouteRedirect_cohortAnalyserRouteTitle__2dVXL"};